import { useTranslation } from 'react-i18next';
import codigoImagen from './CajaImagen.jsx';

const Destinos = ({ destinos, ruta, lang }) => {

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const { t } = useTranslation();

    const parseArray6 = (num) => {
        const chunks = []
        while (num > 6) chunks.push(6), num -= 6;
        chunks.push(num);
        return chunks;
    }

    const estructuraNumPar = num => {
        let primerosDestinos = destinosCopy.slice(0, num);
        destinosCopy.splice(0, num);
        primerosDestinos.forEach((undestino, index) => {
            tempResult = tempResult.concat(
                codigoImagen(undestino, preidioma, ruta, t, "destacats-imatge-desti", "", index, undestino.elnombre)
            );
        });
        result = result.concat(
            <div className={`destacats-desti desti-grid${num}`} key={"dd" + result.length}>
                {tempResult}
            </div>
        );
        tempResult = [];
    }

    let result = [];
    let tempResult = []
    let array = parseArray6(destinos.length)
    let destinosCopy = destinos.slice();

    {
        if (destinos.length == 1) {
            tempResult = tempResult.concat(
                codigoImagen(destinos[0], preidioma, ruta, t, "destacats-imatge-desti", "", 0, t("Ver más") + " " + t("propiedades"))
            );
            result = result.concat(
                <div className="destacats-desti" key={"dd" + result.length}>
                    {tempResult}
                </div>
            );
            tempResult = [];
        }
        else {
            for (let i = 0; i < array.length; i++) {
                if (array[i] === 1) {
                    let primerosDestinos = destinosCopy.slice(0, 1);
                    destinosCopy.splice(0, 1);
                    primerosDestinos.forEach((undestino, index) => {
                        tempResult = tempResult.concat(
                            codigoImagen(undestino, preidioma, ruta, t, "destacats-imatge-desti", "", index, undestino.elnombre)
                        );
                    });
                    result = result.concat(
                        <div className="destacats-desti" key={"dd" + result.length}>
                            {tempResult}
                        </div>
                    );
                    tempResult = [];
                }
                else if (array[i] === 2)
                    estructuraNumPar(2);
                else if (array[i] === 3) {
                    let primerosDestinos = destinosCopy.slice(0, 3);
                    destinosCopy.splice(0, 3);
                    primerosDestinos.forEach((undestino, index) => {
                        tempResult = tempResult.concat(
                            codigoImagen(undestino, preidioma, ruta, t, (index == 2) ? "destacats-imatge-desti3" : "destacats-imatge-desti", (index == 2) ? "mt-2" : "", index, undestino.elnombre)
                        );
                    });
                    result = result.concat(
                        <div className="destacats-desti desti-grid3" key={"dd" + result.length}>
                            {tempResult}
                        </div>
                    );
                    tempResult = [];
                }
                else if (array[i] === 4)
                    estructuraNumPar(4)
                else if (array[i] === 5) {
                    let primerosDestinos = destinosCopy.slice(0, 5);
                    destinosCopy.splice(0, 5);
                    primerosDestinos.forEach((undestino, index) => {
                        tempResult = tempResult.concat(
                            codigoImagen(undestino, preidioma, ruta, t, (index == 3 || index == 4) ? "destacats-imatge-desti5" : "destacats-imatge-desti", (index != 3 || index != 4) ? "d-block" : "", index, undestino.elnombre)
                        );
                    });
                    result = result.concat(
                        <div className="destacats-desti desti-grid5" key={"dd" + result.length}>
                            {tempResult}
                        </div>
                    );
                    tempResult = [];
                }
                else if (array[i] === 6)
                    estructuraNumPar(6)
                else
                    null
            }
        }
    }


    {/* ************* */ }

    return (
        <div className="potblur">
            {
                destinos.length > 1 ?
                    <h2 className="text-center">{t("Nuestros destinos")}</h2>
                    :
                    <h2 className="text-center">{destinos[0].elnombre}</h2>
            }
            <div className="destacats flex-dColumn" style={{ gap: '25px' }}>
                {result}
            </div>
        </div>
    )
}
export default Destinos;
